import React from 'react';
import { isMobile } from 'react-device-detect';

export { SidebarSkeleton } from './ui/desktop/SidebarSkeleton';

const desktopView = React.lazy(() =>
  import('./ui/desktop/DesktopSidebar').then((el) => ({
    default: el.DesktopSidebar,
  }))
);
const mobileView = React.lazy(() =>
  import('./ui/mobile/MobileMenu').then((el) => ({
    default: el.MobileMenu,
  }))
);
export const Sidebar = isMobile ? mobileView : desktopView;

export {
  routeFromSidebarToBlocks,
  routeFromSidebarToVacancies,
  routeFromLogoToStructure,
  routeFromSidebarToSalaryRequest,
} from './model';
